<template>
    <div class="cl_add_edit_title">
        <div class="c_title mb16">
            <span class="c_border pb12 fs16 SysFontM Major_Color"><slot></slot></span>
            <span class="c_right"><slot name="right"></slot></span>
        </div>
    </div>
</template>

<script>
    /**
     * 组件说明：
     * 添加/编辑页面title
     * eg:
     *     <cl-add-edit-title">title</cl-add-edit-title>
     */
    export default {
        name: 'cl-add-edit-title',
        components: {},
        props: {},
        data() {
            return {}
        },

        watch: {},

        computed: {},

        methods: {},

        created() {},

        mounted() {},

        beforeDestroy() {},
    }
</script>
<style lang="scss" scoped>
    .c_title {
        border-bottom: 1px solid $base-border-color-one;
        position: relative;
        .c_border {
            display: inline-block;
            position: relative;

            &::after {
                content: '';
                display: inline-block;
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 3px;
                background-color: $base-color-theme;
                border-radius: 5px 5px 0 0;
            }
        }

        .c_right {
            position: absolute;
            right: 0;
            bottom: 15px;
            display: inline-block;
            width: 22px;
            height: 22px;
        }
    }
</style>
